import { useTheme } from 'next-themes';

import {
  useWorkspaceAgentPanelStore,
  type WorkspaceAgentPanelSurfaceTheme,
} from '~/components/v2/store/features/workspace/useWorkspaceAgentPanelStore';

const isDocumentDark = (): boolean =>
  typeof document !== 'undefined' && document.documentElement.classList.contains('dark');

export const getWorkspaceAgentPanelTheme = ({
  isDocumentDark: documentIsDark = false,
  resolvedTheme,
  surfaceTheme,
}: {
  isDocumentDark?: boolean;
  resolvedTheme?: string;
  surfaceTheme: WorkspaceAgentPanelSurfaceTheme | null;
}): WorkspaceAgentPanelSurfaceTheme => {
  if (surfaceTheme === 'dark' || surfaceTheme === 'light') {
    return surfaceTheme;
  }

  if (resolvedTheme === 'dark') {
    return 'dark';
  }

  if (resolvedTheme === 'light') {
    return 'light';
  }

  return documentIsDark ? 'dark' : 'light';
};

/**
 * Effective panel theme for non-CSS assets (Lottie, etc.). The panel root can carry its own
 * `data-theme` (asset view bridge) that diverges from `next-themes` on the document.
 */
export const useWorkspaceAgentPanelTheme = (): WorkspaceAgentPanelSurfaceTheme => {
  const surfaceTheme = useWorkspaceAgentPanelStore((store) => store.surfaceTheme);
  const { resolvedTheme } = useTheme();

  return getWorkspaceAgentPanelTheme({
    isDocumentDark: isDocumentDark(),
    resolvedTheme,
    surfaceTheme,
  });
};
